import { render, staticRenderFns } from "./ProjectCardState.vue?vue&type=template&id=efa9eb8c&scoped=true"
import script from "./ProjectCardState.vue?vue&type=script&lang=js"
export * from "./ProjectCardState.vue?vue&type=script&lang=js"
import style0 from "./ProjectCardState.vue?vue&type=style&index=0&id=efa9eb8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa9eb8c",
  null
  
)

export default component.exports